export default __webpack_public_path__ + "static/media/3916.0fcf778c.png";